import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Get saved language or browser language
const savedLanguage = localStorage.getItem('i18nextLng');
const browserLanguage = navigator.language.toLowerCase().split('-')[0];
const defaultLanguage = savedLanguage || browserLanguage || 'zh';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: defaultLanguage,
    fallbackLng: 'zh',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    load: 'languageOnly',
    cleanCode: true,
    lowerCaseLng: true
  });

export default i18n;
